import { AxiosError } from 'axios';
import EHttpStatusCodes from 'enums/httpStatusCodes';

import ComponentToast from 'components/utils/Toast';

import IHttpClientError from 'services/httpClient/responses/default/IHttpClientError';

function _httpClientError(err: AxiosError<IHttpClientError>): void {
  const statusHttpCode = err.response?.status;

  if (statusHttpCode === EHttpStatusCodes.BadRequest) {
    const message = err.response?.data.error;

    ComponentToast({
      title: message || 'Bad request',
      type: 'error',
    });

    return;
  }
  if (statusHttpCode === EHttpStatusCodes.UnprocessableEntity) {
    const message = err.response?.data.error;

    ComponentToast({
      title: message || 'Bad request',
      type: 'error',
    });

    return;
  }

  if (statusHttpCode === EHttpStatusCodes.NotFound) {
    const message = err.response?.data.error;

    ComponentToast({
      title: message || 'Not found',
      type: 'error',
    });
    return;
  }

  if (statusHttpCode === EHttpStatusCodes.Conflict) {
    const message = err.response?.data.error;

    ComponentToast({
      title: message || 'Conflict request',
      type: 'error',
    });

    return;
  }

  if (statusHttpCode === EHttpStatusCodes.InternalServerError) {
    ComponentToast({
      title: 'Server unavailable',
      type: 'error',
    });
  }
}

function _appError(message: string): void {
  ComponentToast({
    title: message,
    type: 'error',
  });
}

function errorHandling(err: AxiosError<IHttpClientError>): void {
  if (err.isAxiosError) {
    _httpClientError(err);
    return;
  }

  _appError(err.message);
}

export default errorHandling;
